import { render, staticRenderFns } from "./bxTjzbhxr.vue?vue&type=template&id=e4e02450&scoped=true"
import script from "./bxTjzbhxr.vue?vue&type=script&lang=js"
export * from "./bxTjzbhxr.vue?vue&type=script&lang=js"
import style0 from "./bxTjzbhxr.vue?vue&type=style&index=0&id=e4e02450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e02450",
  null
  
)

export default component.exports